import { useContext } from 'react'

import Context from './context'

export const useLoader = () => {
  const { isLoading } = useContext(Context)

  return isLoading
}
